var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Feature, Layer } from 'react-mapbox-gl';
import * as React from 'react';
var STOP_PAINT = {
    'circle-radius': 6,
    'circle-color': '#f10400',
    'circle-stroke-width': 2,
    'circle-stroke-color': '#fff',
    'circle-stroke-opacity': 1,
};
var Vehicle = /** @class */ (function (_super) {
    __extends(Vehicle, _super);
    function Vehicle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Vehicle.prototype.render = function () {
        return (React.createElement(Layer, { id: "stops", type: "circle", paint: STOP_PAINT }, this.props.coordinates.map(function (coordinates, i) { return React.createElement(Feature, { key: i, coordinates: coordinates }); })));
    };
    return Vehicle;
}(React.PureComponent));
export default Vehicle;



//////////////////
// WEBPACK FOOTER
// ./src/components/MapControl/Stops.tsx
// module id = 1770
// module chunks = 0